export const BASE_URL = "https://messagingtest.vitelglobal.com/nodejs/web";
//export const BASE_URL = "https://chat.onevision.io/nodejs/web/";
export const URL = "https://messagingtest.vitelglobal.com/nodejs/web/company/user";

//http://localhost:8080/web/;
// https://chat.onevision.io/nodejs/web/
